import { useState } from "react";

const CustomButton = ({
  background,
  width,
  height,
  fontStyle,
  fontWeight,
  fontSize,
  color,
  text,
  border,
  icon = false,
  src,
  iconW,
  iconM,
  onClick,
  type = "submit",
  visibility = "visible",
  hoverShadow = "none", // ← opcional y configurable
  className = "",
  minHeight = "28px",
  disabled = false,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <button
      disabled={disabled}
      className={className}
      style={{
        background: background,
        width: width,
        height: height,
        borderRadius: "5px",
        fontFamily: "Nunito",
        fontStyle: fontStyle,
        fontWeight: fontWeight,
        fontSize: fontSize,
        lineHeight: "19px",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        borderWidth: 0,
        color: color,
        justifyContent: "center",
        border: border,
        visibility: visibility,
        cursor: "pointer",
        transition: "box-shadow 0.3s ease",
        boxShadow: hover ? hoverShadow : "none",
        minHeight: minHeight,
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      type={type}
    >
      {icon && (
        <img src={src} alt="" style={{ width: iconW, marginRight: iconM }} />
      )}
      {text}
    </button>
  );
};

export default CustomButton;
